// index.tsx
import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

interface DatatableProps {
  columns: any[];
  dataSource: any[];
  Selection?: boolean | undefined;
  totalEmployees?: number | undefined;
  handleTableChange?: (pagination: any) => void;
  pagination?: {
    current: number;
    pageSize: number;
    total: number;
  };
  // rowKey?: string | ((record: any) => string);
  rowKey?: string;
  rowSelection?: any;
  onSelectionChange?: (selectedRows: any[]) => void; // 🔹 NEW
  isBordered?: boolean;
  // isHideTableTop?: boolean;
  hideSizeChanger?: boolean;
  onRow?: (record: any) => React.HTMLAttributes<any>;
}

// const Datatable: React.FC<DatatableProps> = ({
const Datatable: React.FC<DatatableProps> = ({
  columns,
  dataSource,
  Selection,
  totalEmployees,
  handleTableChange,
  pagination,
  onSelectionChange,
  isBordered = false,
  // isHideTableTop = false,
  hideSizeChanger = false,
  rowKey = "",
  onRow,
}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
  const [searchText, setSearchText] = useState<string>("");
  const [Selections, setSelections] = useState<any>(true);
  const [filteredDataSource, setFilteredDataSource] = useState<any[]>([]);

  // console.log("pagination in table page", pagination);

  const onSelectChange = (newSelectedRowKeys: any[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const handleSearch = (value: string) => {
    setSearchText(value);
    const filteredData = dataSource.filter((record) =>
      Object.values(record).some((field) =>
        String(field)?.toLowerCase()?.includes(value?.toLowerCase()),
      ),
    );
    setFilteredDataSource(filteredData);
  };

  // const rowSelection = {
  //   selectedRowKeys,
  //   onChange: onSelectChange,
  // };

  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys: any, selectedRows: any) => {
      setSelectedRowKeys(newSelectedRowKeys);
      if (onSelectionChange) {
        onSelectionChange(selectedRows);
      }
    },
  };

  useEffect(() => {
    return setSelections(Selection);
  }, [Selection]);

  useEffect(() => {
    setFilteredDataSource(dataSource);
  }, [dataSource]);

  const EmptyText = () => {
    return (
      <div>
        {/* #F36522 */}
        <ExclamationCircleOutlined
          className=" "
          style={{ fill: "#F36522", fontSize: "30px" }}
        />
        <div className="mt-2 d-inlin-flex gap-2">
          <p>No Internet Connection. try again...</p>
        </div>
      </div>
    );
  };

  return (
    <>
      {/* {!hideSizeChanger && ( */}
      <div className={`${hideSizeChanger ? "" : "table-top-data"}`}>
        <div className="row p-3 pt-2 pt-sm-3">
          <div className="col-sm-12 col-md-6">
            <div
              className="dataTables_length"
              id="DataTables_Table_0_length"
            ></div>
          </div>
          <div className="col-sm-12 col-md-6">
            <div
              id="DataTables_Table_0_filter"
              className="dataTables_filter text-end mb-0"
            >
              <label>
                <input
                  type="search"
                  className="form-control form-control-sm"
                  placeholder="Search"
                  aria-controls="DataTables_Table_0"
                  value={searchText}
                  onChange={(e) => handleSearch(e.target.value)}
                />
              </label>
            </div>
          </div>
        </div>
      </div>
      {/* )} */}

      {!Selections ? (
        <Table
          scroll={{ x: "max-content" }}
          bordered={isBordered}
          className="table datanew dataTable no-footer"
          columns={columns}
          rowKey={rowKey} // matches your data
          rowHoverable={false}
          dataSource={filteredDataSource}
          pagination={{
            defaultPageSize: 10,
            current: pagination?.current,
            pageSize: pagination?.pageSize,
            total: pagination?.total,
            locale: { items_per_page: "" },
            showSizeChanger: hideSizeChanger ? false : true,
            pageSizeOptions: ["10", "20", "30"],
            showTotal: (total, range) =>
              `Showing ${range[0]} - ${range[1]} of ${total} entries`,
            nextIcon: <i className="ti ti-chevron-right" />,
            prevIcon: <i className="ti ti-chevron-left" />,
          }}
          onRow={onRow}
          onChange={handleTableChange}
        />
      ) : (
        <Table
          scroll={{ x: "max-content" }}
          bordered={isBordered}
          className="table datanew dataTable no-footer"
          // rowKey={(record) => record.trainer_id ?? record.id}
          rowKey={rowKey}
          rowSelection={rowSelection}
          columns={columns}
          rowHoverable={false}
          dataSource={filteredDataSource}
          pagination={{
            // defaultPageSize: 5,
            defaultPageSize: 10,
            current: pagination?.current,
            pageSize: pagination?.pageSize,
            total: pagination?.total,
            locale: { items_per_page: "" },
            // showSizeChanger: true,
            showSizeChanger: hideSizeChanger ? false : true,
            pageSizeOptions: ["10", "20", "30"],
            showTotal: (total, range) =>
              `Showing ${range[0]} - ${range[1]} of ${total} entries`,
            nextIcon: <i className="ti ti-chevron-right" />,
            prevIcon: <i className="ti ti-chevron-left" />,
          }}
          onRow={onRow}
          onChange={handleTableChange}
        />
      )}
    </>
  );
};

export default Datatable;

// export default Datatable;

{
  /* {!Selections ? (
        <>
          <Table
            className="table datanew dataTable no-footer"
            columns={columns}
            rowKey="id"
            rowHoverable={false}
            dataSource={filteredDataSource}
            // pagination={{
            //   locale: { items_per_page: "" },
            //   total: pagination?.total,
            //   defaultPageSize: 10,
            //   showSizeChanger: true,
            //   pageSizeOptions: ["10", "20", "30"],
            //   nextIcon: <i className="ti ti-chevron-right" />,
            //   prevIcon: <i className="ti ti-chevron-left" />,
            // }}
            pagination={{
              current: pagination?.current,
              pageSize: pagination?.pageSize,
              total: pagination?.total,
              locale: { items_per_page: "" },
              showSizeChanger: true,
              pageSizeOptions: ["10", "20", "30"],
              showTotal: (total, range) =>
                `Showing ${range[0]} - ${range[1]} of ${total} entries`,
              nextIcon: <i className="ti ti-chevron-right" />,
              prevIcon: <i className="ti ti-chevron-left" />,
            }}
            onChange={handleTableChange}
          />
        </>
      ) : (
        <Table
          className="table datanew dataTable no-footer"
          rowSelection={rowSelection}
          columns={columns}
          rowHoverable={false}
          dataSource={filteredDataSource}
          pagination={{
            // total: 100,
            total: totalEmployees ?? 0,
            locale: { items_per_page: "" },
            defaultPageSize: 5,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "30"],
            showTotal: (total, range) =>
              `Showing ${range[0]} - ${range[1]} of ${total} entries`,
            nextIcon: <i className="ti ti-chevron-right" />,
            prevIcon: <i className="ti ti-chevron-left" />,
          }}
        />
      )} */
}
